var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3", on: { click: _vm.onClick } }, [
    _c(
      "div",
      {
        class: [
          _vm.containerClass,
          { "tag-badge-reverse": _vm.reverse, "tag-badge-info": !_vm.reverse }
        ]
      },
      [
        _vm.HasIcon
          ? _c("div", { staticClass: "dot text-center", class: _vm.bgIcon }, [
              _c("em", {
                staticClass: "title-icon",
                class: [_vm.icon, { "is-big-icon": _vm.isBigIcon }]
              })
            ])
          : _vm._e(),
        _c(
          "span",
          {
            staticClass: "tag-badge-title-info pb-0",
            class: [
              _vm.titleClass,
              { "pl-2": _vm.HasIcon, "pl-3": !_vm.HasIcon }
            ]
          },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        )
      ]
    ),
    _vm.hasLine
      ? _c("div", {
          staticClass: "dropdown-divider mt-0 ml-3",
          class: { line: _vm.containerClass.includes("mb") }
        })
      : _vm._e(),
    _c("span", { staticClass: "pb-2", class: _vm.subtitleClass }, [
      _c("em", { class: _vm.subtitleIcon }),
      _vm._v(" " + _vm._s(_vm.subtitle) + " ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }